import React from 'react';
import { Alert, Box, Button, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, TextField, Typography } from '@mui/material';

export interface ServicesContextConflict { field: string; source_value: string; answer_value: string; }

export function ServicesContextConflicts({ conflicts = [] }: { conflicts?: ServicesContextConflict[] }) {
  if (!conflicts.length) return null;
  return <Alert severity="warning" sx={{ my: 2 }}>
    Your answers differ from the current requirement. Review and correct the answer or current requirement before generating the PWS.
    {conflicts.map((conflict) => <Box key={conflict.field} sx={{ mt: 1 }}>
      <Typography variant="body2" fontWeight={700}>{conflict.field === 'work_area' ? 'Work area' : 'Completion target'}</Typography>
      <Typography variant="body2">Current requirement: {conflict.source_value}</Typography>
      <Typography variant="body2">Your answer: {conflict.answer_value}</Typography>
    </Box>)}
  </Alert>;
}

export interface ServicesQuestionInput {
  kind?: string;
  input_type?: string;
  proposed_text?: string;
}

export const isServicesProposal = (question: ServicesQuestionInput) => question.kind === 'proposal';

/** An unanswered proposal stays unselected. Only its version-bound ID is saved. */
export default function ServicesQuestionAnswer({ question, label, value, onChange, onBlur, required = false, disabled = false, minRows = 2 }: {
  question: ServicesQuestionInput; label: string; value: string; onChange: (value: string) => void;
  onBlur?: () => void; required?: boolean; disabled?: boolean; minRows?: number;
}) {
  if (isServicesProposal(question)) return <FormControl fullWidth disabled={disabled} onBlur={onBlur}>
    <RadioGroup row aria-label={label} value={value === 'Yes' || value === 'No' ? value : ''} onChange={(event) => onChange(event.target.value)}>
      <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
      <FormControlLabel value="No" control={<Radio />} label="No" />
    </RadioGroup>
    {value && <Button size="small" disabled={disabled} sx={{ alignSelf: 'flex-start' }} onClick={() => onChange('')}>Clear choice</Button>}
    <FormHelperText>Optional. If you leave this unanswered, the proposed addition will not be included.</FormHelperText>
  </FormControl>;
  return <TextField fullWidth multiline minRows={minRows} required={required} disabled={disabled}
    value={value} placeholder="Enter your answer..." inputProps={{ 'aria-label': label }}
    onChange={(event) => onChange(event.target.value)} onBlur={onBlur} />;
}
